// src/pages/PrivacyPolicy.js
import CmsPage from "../components/pages/CmsPage";

export default function PrivacyPolicy() {
  return (
    <CmsPage
      slug="privacy_policy"
      fallbackTitle="Privacy Policy"
      fallbackContent=""
    />
  );
}
